var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysOrder = function SvgSysOrder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11 12.5V4.709L8.855 6.854a.501.501 0 1 1-.711-.706l3-3a.506.506 0 0 1 .712 0l3 3a.503.503 0 0 1-.163.815.502.502 0 0 1-.548-.11L12 4.7v7.795a.5.5 0 0 1-1 0v.006Zm-6.5.5h-.048a.507.507 0 0 1-.309-.146l-3-3a.498.498 0 0 1 .003-.708.502.502 0 0 1 .708.002l2.145 2.145V3.502a.498.498 0 0 1 .5-.5.498.498 0 0 1 .5.5V11.3l2.144-2.149a.505.505 0 0 1 .711 0 .503.503 0 0 1 0 .705L4.863 12.85a.496.496 0 0 1-.362.158L4.5 13Z"
  })));
};
export default SvgSysOrder;